/*
 * @description:
 * @Author: liwg
 * @Date: 2022-09-19 16:28:15
 * @LastEditors: liwg
 * @LastEditTime: 2022-09-19 16:28:15
 */
import { createContext, useContext } from './useContext'
import type { InjectionKey, Ref } from 'vue'
export interface AppProviderContextProps {
  isMobile: Ref<boolean>
  isPad: Ref<boolean>
  isTouchDevice: Ref<boolean>
  os: string
  browser: string
  deviceType: string
}

const key: InjectionKey<AppProviderContextProps> = Symbol()

export function createAppProviderContext(context: AppProviderContextProps) {
  return createContext<AppProviderContextProps>(context, key)
}

export function useAppProviderContext() {
  return useContext<AppProviderContextProps>(key)
}
